import StdAnimations from "../StdAnimations.js";

export default function StdAnimationModule(element) {
    let animationName = element.getAttribute('data-animation');
    let scrolltrigger = element.getAttribute('data-scrolltrigger');

    let animation = StdAnimations[animationName];

    if (scrolltrigger) {
        animation = {
            ...animation, 
            ...{ scrollTrigger: { trigger:element, end: 'top top' } }
        }
    }

    gsap.from(element, animation);
}
